import { Button } from '@material-ui/core'
import React from 'react'
import { Col, Container, Image, Row } from 'react-bootstrap'
import { Helmet } from 'react-helmet'
import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import OrderImage from '../../../Assets/images/sucess.png'
import { isLogin } from '../../../Helpers/request'

export const Ordersuccess = (props) => {
    const metaDetails = useSelector(state => state.persistedReducer.meta.meta)
    return (
        <>
            <Helmet>
                <meta charSet="utf-8" />
                <title>{metaDetails.title}</title>
                <meta name="description" content={metaDetails.description}></meta>
                <meta name="keywords" content={metaDetails.keywords}></meta>
            </Helmet>
            <div className="gs_myaccount gs_order_success">
                <Container className="gs_customer_container">
                    <Row className="w-100 m-auto">
                        <Col>
                            <Image src={OrderImage} alt="Order Success"></Image>
                            <h1>THANK YOU</h1>
                            <p className="mt-3 d-inline-block">Your Order Was Completed Successfully.</p>

                            <p>Order Id : {props.match.params.order_id}</p>
                            <p>Order No : {props.match.params.order_no}</p>
                            <p>Transaction Id : {props.match.params.txn_id}</p>

                            <p>You can visit the My Account page at any time to check the status
                            of your order.<br />{isLogin ? <span>Or click here to <Link to={"/invoice/" + props.match.params.order_id } target="blank">print a copy of your receipt. </Link> </span>:""} </p>
                        </Col>
                    </Row>
                </Container>
            </div>
        </>
    )
}
